import useApi from './request'

export interface AiRecordingShareDetail {
  recordingId: number
  conferenceId: number
  conferenceType: number
  ownerUserId: string
  displayName: string
  portrait: string
  title: string
  durationSeconds: number
  createAt: string
}

export async function getAiRecordingShareDetailApi(
  recordingId: string | number,
) {
  const { response, request } = useApi<{
    code: number
    message: string
    result?: AiRecordingShareDetail
  }>(`/conference/recording/share/detail/${recordingId}`, {
    method: 'GET',
  })

  await request()
  return response
}
